// Which library offline Desk is working for, resolved ONE way for both kinds of login.
//
//   - Communico staff pick a library (the Partner-nav picker, or Desk's own partner pick): that id.
//   - Library staff never pick anything. The Partner-nav picker reads 0 for them and the server
//     infers their library, which is no help to a PC that must name the library up front to find its
//     own registration, so their own library is read from the sign-in token's `clientId`, the same
//     id the server locks them to (middleware.Claims.AuthClientID). Only a library login
//     (level above 1) is read that way: a Communico login's own client is not a library choice.
//
// Never 0 for a library login with a token. 0 means "no library chosen": say so, never render empty.

import { api } from "../services/api.js";
import { libraryClientId } from "../library/context.js";

export const LAST_LIBRARY_KEY = "cos.desk.last-library";

interface TokenClaims {
	level?: number;
	clientId?: number;
}

function tokenClaims(): TokenClaims | null {
	const token = api.getToken();
	if (!token) return null;
	try {
		const payload = token.split(".")[1];
		if (!payload) return null;
		const b64 = payload.replace(/-/g, "+").replace(/_/g, "/");
		return JSON.parse(atob(b64 + "=".repeat((4 - (b64.length % 4)) % 4))) as TokenClaims;
	} catch {
		return null;
	}
}

/** A library login's own library, from the token; 0 for a Communico login or no token. */
export function ownLibraryId(): number {
	const c = tokenClaims();
	if (!c || typeof c.level !== "number" || c.level <= 1) return 0;
	return typeof c.clientId === "number" && c.clientId > 0 ? c.clientId : 0;
}

/** The library Desk is working in. `partnerClientId` is a Communico staff member's pick on the Desk
 *  page itself; it wins, then the Partner-nav picker, then a library login's own library. */
export function deskLibraryId(partnerClientId?: number): number {
	return partnerClientId ?? (libraryClientId() || ownLibraryId());
}

export function rememberLastLibrary(id: number): void {
	try {
		localStorage.setItem(LAST_LIBRARY_KEY, String(id));
	} catch {
		/* storage unavailable: an offline start then needs the library picked as usual */
	}
}

/** The last library Desk loaded online for on this PC (a library id, not a secret). */
export function lastLibraryId(): number {
	try {
		return Number(localStorage.getItem(LAST_LIBRARY_KEY)) || 0;
	} catch {
		return 0;
	}
}

/** The library an offline start works for: the one in use, else the last one Desk loaded for. */
export function deskStartLibraryId(partnerClientId?: number): number {
	return deskLibraryId(partnerClientId) || lastLibraryId();
}
